// extracted by mini-css-extract-plugin
export default {"core-exclusive":"_2qcV-","coreExclusive":"_2qcV-","cta":"_1kzkN"};